import "../certification/certification.css";
import data from "../../data/data.json";
import useToogleCertification from "../../store/useCertificationStore";

function Certification() {
  const { toggleCertification } = useToogleCertification();

  return (
    <div className="absolute bottom-0 z-[99999] h-[100%] w-[100%] rounded-[0.75rem] flex items-center justify-center certificationModal">
      <div className="bg-primary-background w-[90%] h-[90%] overflow-auto pl-[1.44rem] pr-[1.44rem] rounded-[0.5625rem] certificationInnerContainer">
        <div className="flex items-center justify-between mt-[1.37rem]">
          <div />
          <div className="text-secondary font-[700] leading-[1.375rem]">
            {data.certification[0].title}
          </div>
          <div
            className="w-[1.5rem] h-[1.5rem] cursor-pointer"
            onClick={toggleCertification}
          >
            <img
              src="/innerWidget/closeCertification.svg"
              alt="closecerification"
              className="w-[100%] h-[100%]"
            />
          </div>
        </div>
        <div className="flex items-center justify-center mt-[1.88rem] pb-[1rem]">
          <div className="text-primary font-[400] leading-[1.125rem]">
            {data.certification[1].content}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Certification;
